import { LoaderContainer, LoaderImg } from './styles';
import logo from '../../assets/logo.svg';

export function Loader() {
  return (
    <LoaderContainer>
      <LoaderImg src={logo} alt="Loading" />
      <p>Carregando...</p>
    </LoaderContainer>
  );
}
